import { useEffect, useState, useRef } from 'preact/hooks';
import { isLandingPage, getImageUri, mapBrFromString } from '@/utils';
import { useConfigStore } from '../stores/ConfigStore';
import { useFormStore } from '../stores/FormStore';

function calcLoadHeight(arr, formWidth) {
	try {
		if (formWidth > arr[0]) {
			return arr[1];
		} else {
			return arr[1] * (formWidth / arr[0]);
		}
	} catch (e) {
		return 0;
	}
}

export default function FormHeader({ formKey, setFormHeaderHeight = () => {} }) {
	const {
		properties,
		properties: { conversational },
		text
	} = useConfigStore();
	const { formIsCompleted, formOpen, contentDivRef } = useFormStore();
	const [logoLoaded, setLogoLoaded] = useState(false);
	const headRef = useRef(null);
	useEffect(() => {
		try {
			setFormHeaderHeight(headRef.current?.clientHeight);
		} catch (e) {}
	}, []);

	const HeaderComponent = properties.advanced?.headerElement ?? 'h3';
	const formTitle =
		!formIsCompleted || properties.conversational
			? mapBrFromString(properties.title)
			: typeof properties.thanksPage === 'object'
			? properties.thanksPage.title
			: text?.lastPageTitle;
	const hasLanguageToggle =
		properties?.translation?.useTranslation && properties?.translation?.useToggle;

	const showLogo = properties.logo && (logoLoaded || formOpen || isLandingPage());

	return (
		<div
			id="surveyHead"
			className={`survey-header ${hasLanguageToggle ? 'has-toggle' : ''}`}
			style={conversational ? { margin: 0, position: 'relative' } : {}}
			ref={headRef}
		>
			{showLogo && (
				<img
					onLoad={() => setLogoLoaded(true)}
					style={
						!logoLoaded
							? {
									transition: 'opacity .3s',
									opacity: 0,
									height: calcLoadHeight(
										properties.logoSize,
										contentDivRef.current?.clientWidth
									)
							  }
							: {
									transition: 'opacity .3s',
									opacity: 1
							  }
					}
					src={getImageUri(properties.logo)}
					alt={text?.logoAltText ?? 'Logo'}
				/>
			)}
			<div
				id={`surveyTitle-${formKey}`}
				class="srv-title main-title"
			>
				{formTitle && <HeaderComponent>{formTitle}</HeaderComponent>}
			</div>
		</div>
	);
}
